import {
  OUT_OF_STOCK_SECTION,
  OUT_OF_STOCK_SUCCESS,
  OUT_OF_STOCK_INPUT,
  OUT_OF_STOCK_BUTTON,
  OUT_OF_STOCK_FORM
} from '../../classnames/out-of-stock';

import BaseEmailSubscriptionHandler from '../base-email-subscription-handler';

export default class OutOfStockSubscriptionHandler extends BaseEmailSubscriptionHandler {
  constructor(container) {
    super(
      container,
      OUT_OF_STOCK_FORM,
      OUT_OF_STOCK_SECTION,
      OUT_OF_STOCK_SUCCESS,
      OUT_OF_STOCK_BUTTON,
      OUT_OF_STOCK_INPUT
    );

    this.container = container.querySelector('.js-visible-out-of-stock');
  }

  subscribeToListParams() {
    return ({ ...super.subscribeToListParams(), variantId: this.button.dataset.variantId });
  }
}
